import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  {
    styledContainer: {
      left: "64px",
      position: "relative"
    },
    textFieldsContainer: {
      columnGap: "16px",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      width: "calc(100% - 64px)"
    }
  },
  { name: "CustomerActivitySubfield_Styles" }
);
